import React, { useState } from 'react';
import { walletAPI } from '../services/api';
import toast from 'react-hot-toast';

const SlipViewer = ({ requestId, slipPath, className = "" }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleViewSlip = () => {
    // Open slip in new tab
    const slipUrl = `/api/payment-requests/${requestId}/slip`;
    window.open(slipUrl, '_blank', 'noopener,noreferrer');
  };

  const handleDownloadSlip = async () => {
    setIsLoading(true);
    try {
      await walletAPI.downloadUserSlip(requestId);
      toast.success('Slip downloaded successfully!');
    } catch (error) {
      console.error('Error downloading slip:', error);
      toast.error('Failed to download slip');
    } finally {
      setIsLoading(false);
    }
  };

  if (!slipPath) {
    return (
      <span className={`text-xs text-gray-400 italic ${className}`}>
        No slip uploaded
      </span>
    );
  }

  return (
    <div className={`space-x-2 ${className}`}>
      <button
        onClick={handleViewSlip}
        className="text-xs bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 transition-colors"
        title="View slip in new tab"
      >
        View Slip
      </button>
      <button
        onClick={handleDownloadSlip}
        disabled={isLoading}
        className="text-xs bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        title="Download slip"
      >
        {isLoading ? 'Downloading...' : 'Download'}
      </button>
    </div>
  );
};

export default SlipViewer;
